export default __webpack_public_path__ + "sounds/wrong4.mp3";